module.exports = __webpack_public_path__ + "static/media/my.cd942bda.svg";